import type { Filter_FacetsFragment } from '@generated/graphql'
import { useState } from 'react'

export default function useFilterWithMoreFacets(
  filteredFacets: Filter_FacetsFragment[] | undefined
) {
  const [moreFilter, setMoreFilter] = useState(false)
  const defaultMoreFilter = {
    key: 'filterMore',
    label: !moreFilter ? 'Mais filtros' : 'Menos filtros',
    __typename: 'StoreFacetBoolean' as const,
    values: [],
  }

  if (filteredFacets && filteredFacets?.length > 8) {
    const updateFilteredFacets = filteredFacets

    updateFilteredFacets.splice(7, 0, defaultMoreFilter)

    return {
      updateFilteredFacets,
      moreFilter,
      setMoreFilter,
      status: true,
      indexHide: 7,
    }
  }

  return {
    updateFilteredFacets: filteredFacets,
    indexHide: (filteredFacets?.length ?? 0) - 1,
  }
}
